import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Typography,
} from '@one-thd/sui-atomic-components';
import Steps from './steps';
import DeleteStairModal from '../stairCardModal/deleteStair';
import { addSteps, questionAnswered, updateSteps, editSteps } from '../../actions/stepsAction';
import { stepsSelector } from '../../selectors/steps/steps';
import { selectSelectedCarpetChoice } from '../../selectors/pricing';
import { trackStaircaseYesNo } from '../../utils/analytics/trackEvents';
import StairModelCard from '../stairCardModal';
import {
  AddStairCaseWrapper,
  HorizontalLine,
  StairTitleWrapper,
  AddStepButtonWrapper,
  StairGrids,
} from './styles';

const StairCase = () => {
  const { isEdit, steps } = useSelector(stepsSelector);
  const [show, setShowModal] = useState(false);
  const [showEditStair, setShowEditStair] = useState(false);
  const [showDeleteStair, setShowDeleteStair] = useState(false);
  const stairRef = useRef();
  const dispatch = useDispatch();

  const choosenCarpet = useSelector(selectSelectedCarpetChoice);
  const carpetPrice = choosenCarpet
    ? choosenCarpet.priceSquareYard
    : choosenCarpet;

  const handleAddSteps = () => {
    setShowModal(true);
    trackStaircaseYesNo('yes');
    dispatch(questionAnswered(true));
    dispatch(addSteps(true));
  };

  const handleCloseAddSteps = () => setShowModal(false);
  const handleCloseEditSteps = () => setShowEditStair(false);

  const handleClosedeleteSteps = () => {
    dispatch(editSteps(false));
    setShowDeleteStair(false);
  };

  const deleteStepsConfirmation = (e) => {
    e.preventDefault();
    dispatch(updateSteps(0, carpetPrice));
    dispatch(editSteps(false));
  };

  const editStair = () => {
    setShowEditStair(true);
    setShowDeleteStair(false);
    dispatch(editSteps(true));
  };

  const deleteStair = () => {
    setShowEditStair(false);
    setShowDeleteStair(true);
    dispatch(editSteps(true));
  };

  return (
    <>
      <hr className="horizontal-line" />
      <StairTitleWrapper>
        <Typography variant="h4">Stairs</Typography>
      </StairTitleWrapper>
      <AddStairCaseWrapper>
        {steps > 0 ? (
          <StairGrids>
            <StairModelCard
              id="staircard"
              forwardedRef={stairRef}
              name="Stairs"
              steps={steps}
              editStair={() => editStair()}
              deleteStair={() => deleteStair()}
            />
          </StairGrids>
        ) :
          (
            <AddStepButtonWrapper>
              <Button
                fullWidth
                variant="secondary"
                onClick={handleAddSteps}
              >
                Add Stairs
              </Button>
            </AddStepButtonWrapper>
          )}
      </AddStairCaseWrapper>
      {!isEdit && show && (
        <Steps showModal={show} handleClose={handleCloseAddSteps} />
      )}
      {isEdit && showEditStair && (
        <Steps
          isEdit={isEdit}
          showModal={showEditStair}
          handleClose={handleCloseEditSteps}
        />
      )}
      {showDeleteStair && isEdit && (
        <DeleteStairModal
          showDeleteModal={showDeleteStair}
          title="Delete Stairs"
          bodyText="Are you sure you want to delete this stair with"
          numbreOfSteps={steps}
          onDismiss={() => handleClosedeleteSteps()}
          onConfirmation={(e) => deleteStepsConfirmation(e)}
        />
      )}
    </>
  );
};
export default StairCase;
